// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-PMtU_9","pink":"pink-Jw3whx","violet":"violet-Q_zHea"};